<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
    <!-- <router-link to="/newPage">Go to HomePage</router-link> -->

    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->

    <!-- 路由出口 -->
    <router-view></router-view>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import {mapGetters, mapMutations} from 'vuex'


import { getZgTenantByDomain } from '@/server/home'
// import wx from 'weixin-js-sdk';
// import {getSignature } from '@/server/login';
export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  computed: {
    ...mapGetters(['companyInfo','userInfo','isLogin'])
  },
  data(){
    return {
      settingInfo: {},
      ossUrl: process.env.VUE_APP_PCIMG,
      // 1 : 直接展示页面 2 : 容器里
      type: null,

      currentTheme: null,
      seoForm: {
        code: 'common',
        tenantId: null
      },
      theme: 1,
      footerList: {},
      imageShare: window.location.origin+'/img/qian.3ba4df97.png',
    }
  },
  async created () {
    window.wx.ready(() => {
      window.wx.updateAppMessageShareData({
        title: '年费布局问答表',
        desc: '快来参与问卷调查，获取丰厚奖励！',
        link: window.location.href,
        imgUrl: window.location.origin+'/img/qian.3ba4df97.png',
        success: () => {
          console.log('分享配置设置成功');
        }
      });
    });
    await this.getCompanyInfoByDomain()
    this.initWechatShare();
    //alert(this.isLogin)
    if (!this.isLogin) {
      this.startWechatLogin()
    }
  },
  methods: {
    ...mapMutations(['SET_COMPANYINFO', 'SET_TENANTID', 'SET_OSSFILEURL', 'SET_USERCOLUMNSSETTING']),
    getCompanyInfoByDomain () {
      const doMain =
          window.location.hostname === 'localhost'
              ? ('localhost:' + window.location.port)
              : window.location.hostname
      if ((doMain.indexOf('tsip.yeahip.com') > -1)) {
        sessionStorage.setItem('isPageTs', 1)
      } else {
        // 耶知的登录页面
        sessionStorage.setItem('isPageTs', 2)
      }
      getZgTenantByDomain({ domain: doMain }).then(async (res) => {
        console.log('res', res)
        if (res.code === '0' && res.success) {
          console.log('租户基础数据：', res.data)
          this.SET_COMPANYINFO(res.data)
          this.SET_TENANTID(res.data.id)
          if (res.data.ossFileUrl) {
            this.SET_OSSFILEURL(res.data.ossFileUrl)
          }
          if (res.data) {
            document.title = res.data.shortName
            this.seoForm.tenantId = res.data.id
            sessionStorage.setItem('companyInfo', JSON.stringify(res.data))

            this.isFinished = true
          } else {
            sessionStorage.setItem('companyInfo', '{}')
          }
        } else {
          this.SET_COMPANYINFO({})
          this.SET_TENANTID(null)
        }
      })
    },
    isIndexRoute() {
      const str = window.location.href;
      const hasPublicPage = str.indexOf('/wenJuan') !== -1;
      if(hasPublicPage){
        return  false;
      }
      return this.$route.path === '/' || this.$route.path === '/index' || this.$route.path === '/wenJuan/publicPage';
    },
    startWechatLogin() {
     let pageRoute= window.location.href.split('#')[1];
      if(this.isIndexRoute()){
        return;
      }
      // 微信授权登录
      //let appId = 'wxe8680f410ecb65c4';
       let appId = 'wx9cc9186b5cf570c6';
      let redirectUriUrl = window.location.origin+'/#/publicPage';
      // 检查是否有activityId参数
      if(this.$route.query.activityId) {
        const activityId = this.$route.query.activityId;
        if (activityId != null && activityId != '' && activityId != 'null' && activityId != 'undefined') {
          redirectUriUrl += '?activityId=' + activityId;
        }
      }
      if(this.$route.query.presenter){
        const presenter = this.$route.query.presenter;
        if (presenter != null && presenter != '' && presenter != 'null' && presenter != 'undefined') {
          // 如果有presenter参数，添加到URL中
          if (redirectUriUrl.includes('?')) {
            redirectUriUrl += '&presenter=' + presenter;
          } else {
            redirectUriUrl += '?presenter=' + presenter;
          }
        }
      }
      if (redirectUriUrl.includes('?')) {
        redirectUriUrl += '&redirect_uri=' + encodeURIComponent(pageRoute);
      } else {
        redirectUriUrl += '?redirect_uri=' + encodeURIComponent(pageRoute);
      }
      console.log('redirectUriUrl>>>>>>>>>>>>>>>>>', redirectUriUrl)
      let redirectUri = encodeURIComponent(redirectUriUrl);
       const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE`;
       window.location.href = authUrl;
    },
    initWechatShare() {
      // 获取当前页面URL（不包含hash部分）
      // const currentUrl = window.location.href.split('#')[0];
      let shareLink = window.location.origin+'/#/';
      // 添加活动ID参数
      if(this.$route.query.activityId) {
        const activityId = this.$route.query.activityId;
        if (activityId != null && activityId != '' && activityId != 'null' && activityId != 'undefined') {
          shareLink += '?activityId=' + activityId;
        }
        if(this.userInfo && this.userInfo.id){
          const presenter = this.userInfo.id;
          if (presenter != null && presenter != '' && presenter != 'null' && presenter != 'undefined') {
            if (shareLink.includes('?')) {
              shareLink += '&presenter=' + presenter;
            } else {
              shareLink += '?presenter=' + presenter;
            }
          }
        }
      }
      /*getSignature({url: currentUrl}).then(res => {
        if(res.success){
          wx.config({
            debug: false, // 生产环境设为false
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage']
          });
          if(!this.imageShare || this.imageShare == '' || this.imageShare == 'null' || this.imageShare == 'undefined'){
            this.imageShare = window.location.origin+'/img/qian.3ba4df97.png';
          }
          wx.ready(() => {
            let shareInfo= {
              title: '年费布局问答表',
              desc: '快来参与问卷调查，获取丰厚奖励！',
              link: shareLink,
              imgUrl: this.imageShare,
              success: () => {
                console.log('分享成功');
              },
              cancel: () => {
                console.log('用户取消分享');
              },
              fail: (res) => {
                console.log('分享失败', res);
              }
            }
            if (wx.updateAppMessageShareData) {
              // 设置分享给朋友
              wx.updateAppMessageShareData(shareInfo);
            } else {
              // 添加推荐人参数
              wx.onMenuShareAppMessage(shareInfo);
            }
            if (wx.updateTimelineShareData) {
              // 设置分享到朋友圈
              wx.updateTimelineShareData(shareInfo);
            } else {
              wx.onMenuShareTimeline(shareInfo);
            }
          });
          wx.error((err) => {
            console.error('微信配置失败:', err);
          });
        }
      }).catch(error => {
        console.error('获取签名异常:', error);
      });*/
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>
